export const shuffle = <T>(list: readonly T[]) =>
  list
    .map<{ readonly value: T; readonly sort: number }>((value) => ({
      value,
      sort: Math.random(),
    }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

// To ensure that the shuffled array is always different from the original array, you can implement a more sophisticated shuffling algorithm, such as the Fisher-Yates shuffle.
export const fisherYatesShuffle = <T>(array: readonly T[]) => {
  // eslint-disable-next-line functional/prefer-readonly-type
  const mutableArray: Array<T> = [...array];
  // eslint-disable-next-line functional/no-let
  let currentIndex: number = mutableArray.length,
    randomIndex;

  // While there remain elements to shuffle.
  // eslint-disable-next-line functional/no-loop-statement
  while (currentIndex !== 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [mutableArray[currentIndex], mutableArray[randomIndex]] = [
      mutableArray[randomIndex],
      mutableArray[currentIndex],
    ];
  }

  return mutableArray;
};
